export default __webpack_public_path__ + "static/media/item-3.d83c023f.png";